<template>
  <div>

    <header class="mm-header" :style="{background:background,'color':color}">
      <div @click="gotoruter('/')" :class="{'sort':sortnav}" class="mm-logo pcshow">
        <img src="@/assets/logo.png">
      </div>
      <div class="mm-headerbox">
        <div class="mm-header-left">
          <div @click="changenavsize" class="mm-nav-bar pcshow">
            <svg :style="{'fill':color}" class="icon svg-icon" aria-hidden="true">
              <use xlink:href="#icon-mulu"></use>
            </svg>
          </div>
          <div @click="drawer = true" class="mm-nav-bar wap-nar-bar  wapshow">
            <svg :style="{'fill':color}" class="icon svg-icon" aria-hidden="true">
              <use xlink:href="#icon-mulu"></use>
            </svg>
          </div>
          <div class="mm-sitename min-pcshow"><span>TechTop ERP System</span></div>
        </div>
        <div class="mm-header-right">
          <div class="pcshow2">
            <el-button @click="dialogpwd = true;" icon="el-icon-user" style="border:none;">
              <span class="min-pcshow">{{staff}}</span>
            </el-button>
          </div>
          <div style="margin-left: 15px;" @click="openmsgcenter()">
            <el-badge :value="allmsgnum">
              <el-button>消息中心</el-button>
            </el-badge>
          </div>
          <div style="margin-left: 15px;">
            <el-select class="headermso" @change="changemso" v-model="mso_id" placeholder="請選擇">
              <el-option v-for="(m,i) in mso" :key="m.id" :label="m.name" :value="m.id"></el-option>
            </el-select>
          </div>
        </div>

      </div>
    </header>
    <el-drawer :visible.sync="drawer" :direction="'ltr'" size="250px" :modal-append-to-body="true" :with-header="false">
      <div @click="gotoruter('/');drawer=false;" :style="waplogo">
      </div>
      <div>
        <mmnav :visible.sync="drawer"></mmnav>
      </div>
    </el-drawer>
    <keep-alive>
      <el-drawer :close="closedrawer()" :destroy-on-close="true" :visible.sync="msgdrawer" :direction="'rtl'" size="300px" :modal-append-to-body="true" :with-header="false">
        <component :refresh="refresh" :changepage="changepage" :refim="refim" @closemsgcenter="closemsgcenter" @closedialog="closedialog" :is="msgcenter_component"></component>

      </el-drawer>
    </keep-alive>
    <el-dialog :title="'修改密碼'" :visible.sync="dialogpwd" width="90%" :show-close="false" :close-on-click-modal="false">
      <el-form class="repwd-form" ref="form" :model="form" :rules="rules" :label-width="'120px'" :label-position="'left'">
        <el-form-item label="舊密碼" required prop="oldpassword">
          <el-input type="password" v-model="form.oldpassword" autocomplete="on" clearable></el-input>
        </el-form-item>
        <el-form-item label="新密碼" required prop="password">
          <el-input type="password" v-model="form.password" autocomplete="on" clearable></el-input>
        </el-form-item>
        <el-form-item label="確認密碼" required prop="repassword">
          <el-input type="password" v-model="form.repassword" autocomplete="on" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogpwd = false">{{'取消'}}</el-button>
        <el-button :disabled="pwdloading" type="primary" v-loading="pwdloading" @click="changepwd('form')">{{'確認'}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mmnav from "./Nav.vue";
import msgcenter from "./Message.vue";
export default {
  props: ['sortnav'],
  components: {
    mmnav,
    msgcenter
  },
  data () {
    return {
      pwdloading: false,
      dialogpwd: false,
      form: {},
      waplogo: {
        height: "55px",
        backgroundImage: "url(" + require("@/assets/logo.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center center",
        margin: '10px'
      },
      drawer: false,
      msgdrawer: false,
      mso_id: '',
      mso: {},
      color: '#333',
      background: '#fff',
      allmsgnum: 0,
      msgcenter_component: '',
      refresh: 0,
      refim: 0,
      changepage: '',
      rules: {
        oldpassword: [{
          required: true,
          message: '請輸入舊密碼',
        },
        {
          pattern: /^[\S]+$/,
          message: '只能輸入可見字符'
        },
        {
          pattern: /^(?=.*?[a-zA-Z)(?=.*>[A-Z])(?=.*?[0-9])[a-zA_Z0-9]{6,15}$/,
          message: '密碼必須包含字母和數字,長度在6至15個字符',
          trigger: 'blur'
        }
        ],
        password: [{
          required: true,
          message: '請輸入新密碼',
        },
        {
          pattern: /^[\S]+$/,
          message: '只能輸入可見字符'
        },
        {
          pattern: /^(?=.*?[a-zA-Z)(?=.*>[A-Z])(?=.*?[0-9])[a-zA_Z0-9]{6,15}$/,
          message: '密碼必須包含字母和數字,長度在6至15個字符',
          trigger: 'blur'
        }
        ],
        repassword: [{
          required: true,
          message: '請輸入確認密碼',
        },
        {
          pattern: /^[\S]+$/,
          message: '只能輸入可見字符'
        },
        {
          pattern: /^(?=.*?[a-zA-Z)(?=.*>[A-Z])(?=.*?[0-9])[a-zA_Z0-9]{6,15}$/,
          message: '密碼必須包含字母和數字,長度在6至15個字符',
          trigger: 'blur'
        }
        ],
      }
    };
  },
  computed: {
    staff () {
      return sessionStorage.getItem('username');
    }
  },
  methods: {
    changepwd (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let data = this.form;
          if (data.password != data.repassword) {
            this.$message({
              showClose: true,
              message: '兩次輸入密碼不一致！',
              type: 'error',
            });
            return false;
          }
          let staff_id = sessionStorage.getItem('staff_id');
          data.id = staff_id;

          this.pwdloading = true;
          this.post('/api/user/changepwd', {
            data
          }).then((res) => {
            if (res == 'success') {
              this.$notify({
                showClose: true,
                message: '修改密碼成功, 請重新登錄！',
                type: 'success',
                offset: 60,
              });
              this.dialogpwd = false;
              sessionStorage.clear();
              // 表單提交數據前驗證 valid為驗證結果，驗證通過為true
              this.$router.push({
                name: "Login"
              })
            } else if (res == 'password1') {
              this.$notify({
                showClose: true,
                message: '兩次輸入密碼不一致！',
                type: 'error',
                offset: 60,
              })
            } else if (res == 'password2') {
              this.$notify({
                showClose: true,
                message: '密碼必須包含字母和數字,長度在6至15個字符！',
                type: 'error',
                offset: 60,
              })
            } else if (res == 'oldpassword') {
              this.$notify({
                showClose: true,
                message: '舊密碼不正確！',
                type: 'error',
                offset: 60,
              })
            } else {
              this.$notify({
                showClose: true,
                message: '修改密碼失敗！',
                type: 'error',
                offset: 60,
              })
            }
            this.pwdloading = false;
          }).catch((err) => {
            this.pwdloading = false;
            console.log(err)
          });
        }
      });
      // this.dialogpwd = false;
    },
    closedrawer () {
      this.getallmsgnum();
    },
    getallmsgnum () {
      let user_id = parseInt(sessionStorage.getItem('user_id'));
      this.post('/api/main/allmsgnum', {
        user_id: user_id
      }).then((res) => {
        this.allmsgnum = res;

      })
    },
    closemsgcenter () {
      this.msgdrawer = false;
      this.msgcenter_component = '';
      this.getallmsgnum();

    },
    closedialog () {

      this.msgdrawer = false;
      this.msgcenter_component = '';

    },
    openmsgcenter () {
      this.msgdrawer = true;
      this.msgcenter_component = msgcenter;
    },
    changemso (id) {
      let mso = this.mso;
      this.mso_id = id;
      let username = sessionStorage.getItem('username');
      sessionStorage.setItem('mso_id', id);
      mso.map((m) => {
        if (m.id == id) {
          sessionStorage.setItem('examine_status', this.pwdencode(username+m.examine_status));
          this.color = m.color;
          this.background = m.background;
          this.gotoruter('/');
          return;
        }
      })

    },
    getmso () {
      let mso = JSON.parse(sessionStorage.getItem('mso_list'));
      let mso_id = sessionStorage.getItem('mso_id');
      if (mso && mso.length > 0) {
        if (mso_id) {

          mso.map((m) => {
            if (m.id == mso_id) {
              this.mso_id = m.id;
              this.color = m.color;
              this.background = m.background;
              this.gotoruter('/');
              return;
            }
          })
        } else {
          this.mso_id = mso[0].id;
          this.color = mso[0].color;
          this.background = mso[0].background;
          sessionStorage.setItem('mso_id', mso[0].id);
          this.gotoruter('/');

        }
        this.mso = mso;
      }

    },
    gotoruter (name) {
      if (name == '/') {
        this.$emit("gotohome", true);
      }
      this.$router.push(name);
    },
    changenavsize () {
      if (!this.sortnav) {
        this.$emit("changenavsize", true);
      } else {
        this.$emit("changenavsize", false);
      }

    },
    check_login () {
      let mso_id = sessionStorage.getItem('mso_id');
      let username = sessionStorage.getItem('username');
      let token = sessionStorage.getItem('token');
      if (!mso_id || !username || !token) {
        this.$router.push({
          name: "Login"
        })
      }
    },
    reconnect () {
      if (lockReconnect) return;
      lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      setTimeout(() => {
        this.websocket();
        console.log("正在重连，当前时间" + new Date())
        renum++;
        lockReconnect = false;
      }); //这里设置重连间隔(ms)
    },
    websocket () {
      this.post('/api/main/databasename', {
      }).then((res) => {
        let databasename = res;
        localStorage.setItem('databasename', databasename);
        if (databasename) {
          var heartCheck = {
            timeout: 10000, //毫秒
            timeoutObj: null,
            serverTimeoutObj: null,
            reset: function () {
              clearTimeout(this.timeoutObj);
              clearTimeout(this.serverTimeoutObj);
              return this;
            },
            start: function () {
              var self = this;
              this.timeoutObj = setTimeout(function () {
                //这里发送一个心跳，后端收到后，返回一个心跳消息，
                //onmessage拿到返回的心跳就说明连接正常
                let swoolecontent = {
                  'type': 'ping',
                  'content': 'ping'
                }
                websocket.send(JSON.stringify(swoolecontent));

                self.serverTimeoutObj = setTimeout(function () { //如果超过一定时间还没重置，说明后端主动断开了
                  websocket.close(); //如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
                }, self.timeout)
              }, this.timeout)
            }
          }
          let user_id = parseInt(sessionStorage.getItem('user_id'));
          let wsServer = 'wss://ws.techtop.com.hk:10000?database=' + databasename + '&user_id=' + user_id;
          websocket = new WebSocket(wsServer);
          websocket.onopen = (evt) => {
            console.log('wsopen');

            heartCheck.reset().start();

          };
          websocket.onclose = (evt) => {
            console.log('wscolse');
            console.log(renum);
            if (renum < 5) {
              this.reconnect();
            } else {
              sessionStorage.clear();
              window.location.reload();
            }

          };
          websocket.onmessage = (evt) => {
            let data = JSON.parse(evt.data);

            heartCheck.reset().start();
            if (data.type == 'pong') {

            } else if (data.type == 'message') {
              this.getallmsgnum();
              this.refresh = Math.random();
              let that = this;
              this.$notify({
                title: '订单消息',
                type: 'success',
                dangerouslyUseHTMLString: true,
                message: '<div style="display:flex;align-items: center">' +
                  '<div><img style="width:30px;height:30px; border-radius:50%;margin-right:10px" src="' + this.apiurl +
                  data.thumb + '"></div>' +
                  '<div style="display:flex;align-items: center"><strong>' + data.username + '</strong>:' + data.content +
                  '</div>' +
                  '</div>',
                duration: 0,
                onClick: function () {
                  that.msgdrawer = true;
                  that.msgcenter_component = msgcenter;
                  this.close();
                }
              });
            } else if (data.type == 'im') {
              this.getallmsgnum();
              this.refim = Math.random();
              let that = this;
              this.$notify({
                title: 'IM消息',
                type: 'success',
                dangerouslyUseHTMLString: true,
                message: '<div style="display:flex;align-items: center">' +
                  '<div><img style="width:30px;height:30px; border-radius:50%;margin-right:10px" src="' + this.apiurl +
                  data.thumb + '"></div>' +
                  '<div><strong>' + data.username + '</strong>:' + data.content + '</div>' +
                  '</div>',
                duration: 0,
                onClick: function () {
                  that.msgdrawer = true;
                  that.msgcenter_component = msgcenter;
                  that.changepage = 'imlist';
                  this.close();
                }
              });
            }

          };

          websocket.onerror = function (evt, e) {
            console.log('Error occured: ' + evt.data);

          };
        }

      })


    },


  },
  created () {
    this.getallmsgnum();
    this.websocket();
    this.check_login();
    this.getmso();

  }


};
</script>
<style>
.mm-header {
  height: 75px;
  background: #fff;
  flex: 1;
  display: flex;
  box-shadow: 0 3px 16px 0 rgba(0, 0, 0, 0.1);
}

.mm-logo {
  transition: all 0.3s;
  width: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 0;
  cursor: pointer;
  margin-right: 10px;
}

.mm-logo.sort {
  width: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mm-logo.sort img {
  height: 30px;
}

.mm-logo img {
  transition: all 0.3s;
  margin: 5px auto;
  height: 90%;
}

.mm-headerbox {
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
}

.mm-nav-bar {
  cursor: pointer;
  display: flex;
  width: 45px;
  height: 45px;
  overflow: hidden;
  border-radius: 50%;
  background: transparent;
  justify-content: center;
  align-items: center;
}

.mm-nav-bar svg {
  font-size: 30px;
  fill: #333;
  font-weight: bold;
}

.mm-nav-bar:hover {
  background: rgba(0, 0, 0, 0.05);
}

.mm-header-left {
  display: flex;
  align-items: center;
}

.mm-sitename {
  font-size: 20px;
}

.mm-header-right {
  padding-right: 20px;
  display: flex;
}

.mm-body {
  height: calc(100vh - 75px);
  display: flex;
}

.wap-nav-bar {
  padding: 0 20px;
}

.wapshow {
  display: none;
}

@media (max-width: 1280px) {
  .pcshow {
    display: none !important;
  }

  .wapshow {
    display: flex;
  }
}

@media (max-width: 640px) {
  .min-pcshow {
    display: none;
  }
}

@media (max-width: 320px) {
  .pcshow2 {
    display: none !important;
  }
}
</style>
